import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CallHistoryItem, fetchCallHistoryLookup } from "../thunks/fetchCallHistoryLookup";

export interface BaseFlow {
  id: string;
  destination: string | number;
  flow_duration: number;
  answered?: boolean;
  answered_at?: string;
  hangup?: boolean;
  hangup_at?: string;
  transfer_type?: string;
  transferred?: boolean;
  transferred_at?: string;
  application?: {
    app: 'ivr' | 'callcenter' | string;
    data?: string;
  };
}

export interface CallCenterFlow extends BaseFlow {
  application: {
    app: 'callcenter';
    data: string;
  };
  callcenter: {
    name: string;
    agent: string | null;
    agentNumber: string | number | null;
    status: 'answered' | 'cancel' | 'timeout' | string;
    enteredAt?: string;
    answeredAt?: string;
    canceledAt?: string;
    cancelReason?: string;
    queueID?: string;
  };
}

export interface IVRFlow extends BaseFlow {
  application: {
    app: 'ivr';
    data: string;
  };
}

export type CallFlow = CallCenterFlow | IVRFlow | BaseFlow;

export interface CallHistoryRecord {
  id: string;
  caller_id_name: string;
  caller_id_number: string;
  dialed_number: string;
  dialed_extensions?: string[];
  start_timestamp: string;
  end_timestamp?: string;
  answer_timestamp?: string;
  duration: string;
  call_direction: 'inbound' | 'outbound';
  missed_call: boolean;
  recorded: boolean;
  call_flow?: {
    flows: CallFlow[];
  };
  user_ext:string|null
}



interface CallHistoryState {
  data: CallHistoryItem[];
  loading:boolean;
}

const initialState: CallHistoryState = {
  data: [],
  loading:false
};

const callHistorySlice = createSlice({
  name: "callHistory",
  initialState,
  reducers: {
    clearCallHistory: (state) => {
      state.data = [];
      state.loading = false
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchCallHistoryLookup.pending, (state) => {
        state.loading = true; 
      })
    .addCase(
      fetchCallHistoryLookup.fulfilled,
      (state, action: PayloadAction<CallHistoryItem | undefined>) => {
        state.loading = false;
        if (!action.payload) return;

        const existingIndex = state.data.findIndex(
          (item) => item.id === action.payload?.id
        );

        if (existingIndex !== -1) {
          state.data[existingIndex] = action.payload;
        } else {
          state.data.push(action.payload);
        }
      }
    )
    .addCase(fetchCallHistoryLookup.rejected, (state) => {
        state.loading = false; 
      });
  },
});

export const { clearCallHistory } = callHistorySlice.actions;
export default callHistorySlice.reducer;
